interface Props {
  onClick?: () => void;
  icon?: boolean;
  block?: boolean;
  primary?: boolean;
  size?: "sm";
  children: React.ReactNode;
  disabled?: boolean;
}

export default function Button({
  onClick,
  icon,
  block,
  primary,
  size,
  children,
  disabled,
}: Props) {
  let blockClass = "";
  let iconClass = "";
  let colourClass = "";
  let sizeClass = "";

  if (block) {
    blockClass = "w-full";
  }

  if (icon) {
    iconClass = "justify-between";
  } else {
    iconClass = "justify-center";
  }

  if (primary) {
    colourClass = "bg-purple-300 border-purple-300";
  } else {
    colourClass = "bg-slate-300 border-slate-200";
  }

  if (size === "sm") {
    sizeClass = "px-sm py-xs";
  } else {
    sizeClass = "px-md py-sm";
  }

  return (
    <button
      onClick={onClick}
      className={`flex items-center gap-sm rounded-md border text-left font-semibold disabled:cursor-not-allowed disabled:opacity-50 ${sizeClass} ${blockClass} ${colourClass} ${iconClass}`}
      disabled={disabled}
    >
      {children}
    </button>
  );
}
